import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconCampaignTracking = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M13 16L20.0507 4.13713" stroke="currentColor" strokeLinecap="round" />
      <path d="M12.449 15.6787L11 11" stroke="currentColor" strokeLinecap="round" />
      <path d="M7 16.6787L11 11" stroke="currentColor" strokeLinecap="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M21.75 5.90549V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5C2.25 3.48122 3.48122 2.25 5 2.25H18.0945C18.0328 2.48971 18 2.74103 18 3C18 3.25897 18.0328 3.51029 18.0945 3.75H5C4.30964 3.75 3.75 4.30964 3.75 5V19C3.75 19.6904 4.30964 20.25 5 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V5.90549C20.4897 5.96719 20.741 6 21 6C21.259 6 21.5103 5.96719 21.75 5.90549Z" fill="currentColor" />
      <circle cx="21" cy="3" r="1.5" fill="white" stroke="currentColor" />
      <circle cx="13" cy="16" r="1.5" fill="white" stroke="currentColor" />
      <circle cx="7" cy="17" r="1.5" fill="white" stroke="currentColor" />
      <circle cx="11" cy="11" r="1.5" fill="white" stroke="currentColor" />
    </svg>
  )
}

export default IconCampaignTracking
